module.exports = __webpack_public_path__ + "assets/5cff07beab63ec777fc73ac0483811b0.woff2";


//////////////////
// WEBPACK FOOTER
// ../~/@fontsource/roboto/files/roboto-greek-ext-400-normal.woff2
// module id = 2631
// module chunks = 121